import React, { Component } from "react";

import PhotoWall from "../../components/HomeSections/PhotoWall/Photowall";
import Seal from "../../components/HomeSections/Seal/Seal";
// import Message from "../../components/HomeSections/Message/Message";
import LargePhoto from "../../components/UI/LargePhoto/LargePhoto";
import crosswalkImage from "../../assets/images/margee-quote-resized.jpg";
import MargeeQuote from "../../components/HomeSections/MargeeQuote/MargeeQuote";
import NextPage from "../../components/UI/NextPage/NextPage";
import { Helmet } from "react-helmet";

class Home extends Component {
  componentDidMount() {
    try {
      window.scroll({
        top: 0,
        left: 0,
      });
    } catch (error) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return (
      <React.Fragment>
        <Helmet>
        <meta charSet="utf-8" />
          <title>Dickinson Viewbook</title>
        </Helmet>
        <PhotoWall />
        <Seal />
        {/* <Message /> */}
        <MargeeQuote />
        <LargePhoto
          src={crosswalkImage}
          alt="Student walking across crosswalk"
        />
        <NextPage link="/identity" title="Our Identity" />
      </React.Fragment>
    );
  }
}

export default Home;
